import { Injectable } from '@angular/core';
import { HttpClient, HttpHeaders } from '@angular/common/http';
import { Observable } from 'rxjs';
import { environment } from '../../../environments/environment';

export interface ServicioRealizado {
  id?: number;
  sistema: string;
  parte: string;
  tipo_de_mantenimiento: string;
  estado: number;
}


@Injectable({
  providedIn: 'root',
})
export class ServicioRealizadoService {
  private apiUrl =  `${environment.apiUrl}/api/servicio_realizado`; 
  //private apiUrl = 'http://localhost:3000/api/servicio_realizado'; // cambia si tu puerto/backend es otro

  constructor(private http: HttpClient) {}

  private getAuthHeaders(): HttpHeaders {
    const token = localStorage.getItem('token'); // o donde almacenes el token
    return new HttpHeaders({
      'Content-Type': 'application/json',
      Authorization: `Bearer ${token}`,
    });
  }

    getAll(): Observable<{ data: ServicioRealizado[] }> {
    return this.http.get<{ data: ServicioRealizado[] }>(this.apiUrl, { headers: this.getAuthHeaders() });
    }

  getById(id: number): Observable<ServicioRealizado> {
    return this.http.get<ServicioRealizado>(`${this.apiUrl}/${id}`, {
      headers: this.getAuthHeaders(),
    });
  }

  create(data: ServicioRealizado): Observable<ServicioRealizado> {
    return this.http.post<ServicioRealizado>(this.apiUrl, data, {
      headers: this.getAuthHeaders(),
    });
  }

  update(id: number, data: ServicioRealizado): Observable<ServicioRealizado> {
    return this.http.put<ServicioRealizado>(`${this.apiUrl}/${id}`, data, {
      headers: this.getAuthHeaders(),
    });
  }

  delete(id: number): Observable<any> {
    return this.http.delete(`${this.apiUrl}/${id}`, {
      headers: this.getAuthHeaders(),
    });
  }
}